function SiteHeaderModule() { }

SiteHeaderModule.Extend(Module);

SiteHeaderModule.prototype.settings = {
	
};

SiteHeaderModule.prototype.elementMap = {
	"searchDrawerExpanded" : "div.searchDrawer",
	"searchDrawerCollapsed" : "div.searchDrawerCollapsed",
	"expandArrow" : "div.searchDrawerCollapsed div.arrow",
	"projectsMenu" : "div.menuContainer",
	"ticketTrackerButton" : "div.primaryNav > ul > li:first-child",
	"timeZoneSelect" : "div.timeZoneDropdown > button > span.selectedVal",
	"timeZoneDropdown" : "div.timeZoneDropdown > button",
	"dateFormatSelect" : "div.dateFormatDropdown > button > span.selectedVal",
	"dateFormatDropdown" : "div.dateFormatDropdown > button",
	"searchField" : "div.searchContainer > div.input > input"
};

SiteHeaderModule.prototype.initModule = function () {
	this.optionalFields = [];
	$("span.popoverHandle.gear").popover({html: true, content: $.proxy(this.getSettingsContent,this)}).on("hide", $.proxy(this.settingsHide,this));
	this.attachExtraEvents();
	this.$el("input[placeholder]",true).placeholder();

	this.settingsRequests = 0;
	this.reloadIterations = 0;
};

SiteHeaderModule.prototype.getSettingsContent = function() {

	if(this.currentSettingsContent) {
		return this.currentSettingsContent;
	}
	else {
		return $("div.settingsContainer").attr("data-settingsmenu");
	}

};

SiteHeaderModule.prototype.attachExtraEvents = function() {
	$("body").on("click", function(e) {
		var $ev = $(e.target);
		if($ev.parents(".popover").length > 0 || $ev.hasClass("popoverHandle") || $("div.settingsPanel:visible").length == 0) {
			return;
		}
		$("span.popoverHandle").popover("hide");
	});
};

SiteHeaderModule.prototype.settingsHide = function() {
	var self = this;
	var updatedHtml = $("div.popover-content").html();

	this.currentSettingsContent = updatedHtml;
	this.doReload();
};

SiteHeaderModule.prototype.doReload = function() {
	if(this.settingsRequests == 0 || this.reloadIterations > 5) {
		console.log("Reloading");
		location.href = location.href;
	}
	else {
		console.log("Settings aren't saved yet. [" + this.settingsRequests + "] Waiting...");
		this.reloadIterations++;
		window.setTimeout($.proxy(this.doReload,this),500);
	}
}

SiteHeaderModule.prototype.action_collapseSearch = function () {
	//this.$el("searchDrawerCollapsed").show();
	this.$el("searchDrawerExpanded").slideToggle(400, $.proxy(function() {
		this.$el("expandArrow").show();
	},this));
};

SiteHeaderModule.prototype.action_expandSearch = function () {
	this.$el("expandArrow").hide();
	//this.$el("searchDrawerCollapsed").hide();
	this.$el("searchDrawerExpanded").slideToggle(400);
};

SiteHeaderModule.prototype.action_loadProject = function($el, val) {
	var url = "~/ProjectList/LoadPreferredTicketView/?projectid=" + val; 

	location.href = url.resolveUrl();
};

SiteHeaderModule.prototype.action_search = function($el, val, e) {
	if((e.type == "keyup" && e.keyCode == 13) || e.type == "click") {
		var keywords = this.$el("searchField").val();
		var url = "~/TicketSearch/?reset=1&keywords=" + keywords; 

		location.href = url.resolveUrl();
	}
};

SiteHeaderModule.prototype.action_projectsMenu = function ($el, val, e) {
	var $target = e.toElement ? $(e.toElement) : $(e.relatedTarget);
	if(e.type == 'mouseenter') {
		this.$el("projectsMenu").show();
		this.$el('ticketTrackerButton').addClass('activeDropdown');
	}
	else if(e.type == 'mouseleave' && !$target.hasClass('ignoreMouseLeave')) {
		this.$el("projectsMenu").hide();
		this.$el('ticketTrackerButton').removeClass('activeDropdown');
	}
};

SiteHeaderModule.prototype.action_updateTimeZone = function ($el, val, e) {

	var matches = $el.text().match(/^\(([^\(]+)\)/);

	var lbl = (matches && matches.length > 1) ? matches[1] : $el.text();

	this.$el("timeZoneSelect").text(lbl);

	this.selectedTimeZone = val;

	this.$el("timeZoneDropdown").dropdown("toggle");

	this.saveSettings();
};

SiteHeaderModule.prototype.action_updateDateFormat = function ($el, val, e) {

	this.$el("dateFormatSelect",true).text($el.text());

	this.selectedDateFormat = val;

	this.$el("dateFormatDropdown").dropdown("toggle");

	this.saveSettings();
};

SiteHeaderModule.prototype.action_updateFields = function($el, val) {
	var field = $el.val();
	if(val) {
		$el.attr('checked','checked');
	}
	else {
		$el.removeAttr('checked');
	}

	this.saveSettings();
	
};

SiteHeaderModule.prototype.saveSettings = function () {
	var self = this;
	$("div.settingsPanel input[type='checkbox']").each(function() {
		var $el = $(this);
		if($el.is(":checked")) {
			self.optionalFields.push($el.val());
		}
	});
	if(this.settingsReq) {
		this.settingsReq.abort();
	}
	this.settingsRequests++;
	this.settingsReq = this.ajax({
		url: '~/UserInfo/SaveSettings',
		data: {
			tz: this.selectedTimeZone,
			df: this.selectedDateFormat,
			of: this.optionalFields.join('|')
		},
		success: function() {

		},
		complete: $.proxy(function(data,sts) {
			Util.checkSessionTimeout(data);
			this.settingsRequests--;
		},this)
	});

	self.optionalFields = [];
};